import { render, staticRenderFns } from "./hotCourseCard.vue?vue&type=template&id=599d5c26&scoped=true&"
import script from "./hotCourseCard.vue?vue&type=script&lang=js&"
export * from "./hotCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./hotCourseCard.vue?vue&type=style&index=0&id=599d5c26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d5c26",
  null
  
)

export default component.exports